import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const pdfService = {
    /**
     * Génère un PDF à partir d'un élément HTML
     */
    async generatePDFFromHTML(elementId, fileName = 'document.pdf') {
        try {

            const element = document.getElementById(elementId);
            if (!element) {
                throw new Error(`Élément avec l'ID "${elementId}" non trouvé`);
            }


            // Convertir l'élément HTML en canvas avec options optimisées
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                allowTaint: true,
                foreignObjectRendering: false,
                windowHeight: element.scrollHeight,
                windowWidth: element.scrollWidth,
                imageTimeout: 0,
                removeContainer: true,
            });


            // Vérifier que le canvas est valide
            if (!canvas || canvas.width === 0 || canvas.height === 0) {
                throw new Error('Canvas généré est invalide');
            }

            // Convertir en image JPEG (meilleure compression)
            const imgData = canvas.toDataURL('image/jpeg', 0.95);

            if (!imgData || imgData.length < 100) {
                throw new Error('Image générée est invalide');
            }


            // Créer le PDF avec les bonnes dimensions
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
                compress: true,
            });

            const pageWidth = pdf.internal.pageSize.getWidth(); // 210mm
            const pageHeight = pdf.internal.pageSize.getHeight(); // 297mm

            // Calculer les dimensions de l'image
            const imgWidth = pageWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;


            // Si le contenu tient sur une page, ne pas ajouter de page vide
            if (imgHeight <= pageHeight) {

                pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            } else {
                // Ajouter les pages nécessaires
                let position = 0;
                let heightLeft = imgHeight;

                while (heightLeft > 0) {
                    if (position !== 0) {
                        pdf.addPage();
                    }

                    pdf.addImage(imgData, 'JPEG', 0, -position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                    position += pageHeight;
                }
            }

            return pdf;
        } catch (error) {
            console.error('[pdfService] Erreur génération PDF:', error);
            throw error;
        }
    },

    /**
     * Télécharge le PDF
     */
    downloadPDF(pdf, fileName = 'document.pdf') {
        try {

            pdf.save(fileName);

        } catch (error) {
            console.error('[pdfService] Erreur téléchargement:', error);
            throw error;
        }
    },

    /**
     * Convertit le PDF en Blob pour l'envoi
     */
    pdfToBlob(pdf) {
        try {

            const blob = pdf.output('blob');

            return blob;
        } catch (error) {
            console.error('[pdfService] Erreur conversion:', error);
            throw error;
        }
    },
};
